import React, { Fragment, useEffect, useRef, useState } from "react";
// import Button from "../components/common/button"; // Preserved for old code
import { useNavigate } from "react-router-dom";
import * as userService from "../utils/userService";
import * as httpService from "../services/httpService";
import { Employee_Api_EndPoints } from "../global/end-points";
import LoadingSpinner from "../components/common/loadingSpinner";
import { useTranslation } from "react-i18next";
import NoDoughCardMessage from "../components/common/nodoughcard_message";
import PrivilegeService from "../services/PrivilegeService";


function DoughCard() {
  const { t } = useTranslation();
  let navigate = useNavigate();
  const [isLoad, setIsLoad] = useState(false);
  const didMount = useRef(false);
  const [balance, SetBalance] = useState(0);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [cardLast4Digits, setCardLast4Digits] = useState(""); // Preserved for old code
  const [errorMessage, setErrorMessage] = useState({
    title: "warning",
    content: "This is a sample content"
  });
  const [isError, setIsError] = useState(false);
  const [privilegesChecked, setPrivilegesChecked] = useState(false);

  useEffect(() => {
    // Get privileges from sessionStorage
    const privilegesObj = JSON.parse(sessionStorage.getItem("Privileges") || "{}");
    const hasAccess = PrivilegeService.hasReadAccess(privilegesObj, "DoughCard");
    if (!hasAccess) {
      setErrorMessage({
        title: "Access Denied",
        content: "You do not have permission to view this page."
      });
      setIsError(true);
      setPrivilegesChecked(true);
    } else {
      setPrivilegesChecked(true);
      if (!didMount.current) {
        getBalance();
      }
    }
    return () => {
      didMount.current = true;
    };
  }, []);

  const getBalance = () => {
    if (sessionStorage.UserId != undefined) {
      const body = {
        UserId: Number(sessionStorage.UserId),
      };
      httpService.Get(Employee_Api_EndPoints.GET_BALANCE, body).then((resp) => {
        // ✅ Handle 500 errors and other error responses gracefully
        // When pay period is completed, backend may return 500 - display 0 balance instead of error
        if (resp && resp.status === 200 && resp.data && !resp.data.errorFound) {
          if(typeof resp.data.cardBalance === 'undefined' && typeof resp.data.cardLast4Digits === 'undefined'){
            setDoughCardError();
          }
          else{
            SetBalance(resp.data.cardBalance || 0);
            setCardLast4Digits(resp.data.cardLast4Digits || "");
          }
        }
        else
        {
          // Check if this is a 500 error (completed pay period scenario)
          const is500Error = resp && resp.response && resp.response.status === 500;
          
          if (is500Error) {
            // 500 error - likely completed pay period, just set balance to 0
            // Don't show error popup - this is expected behavior
            SetBalance(0);
            setCardLast4Digits("");
          } else {
            // Other errors - show error popup
            SetBalance(0);
            setCardLast4Digits("");
            setDoughCardError();
          }
        }
        setIsLoad(true);
      }).catch((error) => {
        // Additional catch for any unhandled errors
        console.error("Error fetching balance:", error);
        // For 500 errors (completed pay period), just set balance to 0
        if (error && error.response && error.response.status === 500) {
          SetBalance(0);
          setCardLast4Digits("");
          // Don't show error popup for 500 errors
        } else {
          SetBalance(0);
          setCardLast4Digits("");
          setDoughCardError();
        }
        setIsLoad(true);
      });
    } else {
      setIsLoad(true);
      userService.ClearSession();
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const toNavigate = (event) => {
    // Preserved for old code - used in commented section below
    event.preventDefault();
    switch (event.target.value) {
      case "tranctions":
        navigate("/servicetransaction");
        break;
      case "doughdepotransaction":
        navigate("/depotransaction");
        break;
      case "dchtobank":
        navigate("/achtransaction");
        break;
      case "otherActions":
        navigate("/othertransaction");
        break;
    }
  };

  const setDoughCardError = () => {
    setErrorMessage({
      title: 'Message',
      content: "Your Card creation is pending, this may take few minutes. If it takes too long please contact support team"
    });
    setIsError(true);
  }

  const handleClosePopup = () => {
    setIsError(false);
  }

  // Wait for privilege check before rendering anything
  if (!privilegesChecked) return <LoadingSpinner />;

  return (
    <Fragment>
      {isLoad && !isError && (
        <Fragment>
          {/* <!-- dashboard main start --> */}
          <div className="dashboard-container">
            {/* New Simplified Design */}
            <h2 className="dough-card-page-title">{t("YourDoughCard")}</h2>
            <div className="dough-card-simple-container">
              <div className="dough-card-icon-large">
                <div className="card-icon-stripe"></div>
                <div className="card-icon-dash card-icon-dash-1"></div>
                <div className="card-icon-dash card-icon-dash-2"></div>
              </div>
              <p className="dough-card-balance-text">
                You have <span className="dough-card-balance-amount">${balance.toFixed(2)}</span> on your Dough Card
              </p>
            </div>
            <div className="dough-card-recent-transactions-bar" onClick={() => navigate("/servicetransaction")}>
              <span className="dough-card-recent-transactions-text">{t("RecentDoughCardTrs")}</span>
            </div>

            {/* OLD CODE - PRESERVED BELOW */}
            {/* 
            <h2 className="page-module-heading mb-15">{t("YourDoughCard")}</h2>
            <div className="your-dough-card-continer">
              <div className="summary-card-inner">
                <div className="summary-card-details">
                  <h2 className="card-heading">{t("doughcardsummary")}</h2>
                  <h2 className="wages-heading">{t("doughcardWagestoAccess")}</h2>
                  <h2 className="wage-amount-no-link">
                    $ {balance.toFixed(2)}
                  </h2>
                  <h3 className="wage-card-number">**** **** **** {cardLast4Digits}</h3>
                  <div className="card-holder-details-provider">
                    <div className="card-holder-details">
                      <div className="valid">
                        Valid Thru
                        <span>08/28</span>
                      </div>
                      <div className="valid">
                        Card holder
                        <span>{sessionStorage?.UserName}</span>
                      </div>
                    </div>
                    <div className="card-provider-symbol">
                      <img src="./images/card-provider-logo.svg" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <h2 className="page-module-heading">
              {t("Youhave")}{" "}
              <span className="color-white">$ {balance.toFixed(2)}</span> {t("yourDoughCard")}
            </h2>
            <div className="paydata-home mt-30">
              <Button
                className="btn btn-paydata w-100-percent"
                label={t("RecentDoughCardTrs")}
                value="tranctions"
                onClick={toNavigate}
              />
               <Button
                className="btn btn-paydata w-100-percent"
                label={t("RecentDoughDepoTrs")}
                value="doughdepotransaction"
                onClick={toNavigate}
              />
              <Button
                className="btn btn-paydata w-100-percent"
                label={t("DhAchBank")}
                value="dchtobank"
                onClick={toNavigate}
              />
              <Button
                className="btn btn-paydata w-100-percent"
                label={t("OtherAct")}
                value="otherActions"
                onClick={toNavigate}
              />
            </div>
            */}
          </div>
          {/* <!-- dashboard main end --> */}
        </Fragment>
      )}
      {!isLoad && !isError && <LoadingSpinner />}
      {isError && (
        <NoDoughCardMessage 
          title={errorMessage.title}
          message={errorMessage.content}
          onClose={handleClosePopup}
        />
      )}
    </Fragment>
  );
}
export default DoughCard;
